import { mapGetters } from 'vuex'
import MessageMixin from '@/mixins/message'
import { formatDisplayDateTime4 } from '@/utils/date'

export const paymentViewMixin = {
  data() {
    return {
      paymentForm: {
        actionName: null,
        branch: null,
        accountNo: null,
        documentNo: null,
        transactionType: 'Z',
        docAE: true,
        transactionDate: null,
        payTo: null,
        bankNo: null,
        fromBank: null,
        fund: null,
        accountNoSuffix: '',
        cashBook: null,
        gstIO: null,
        gstStatus: null,
        gstRate: null,
        amountCurr: null,
        amount: (0.00).toFixed(2),
        gstAmountCurr: null,
        amountCurrRate: (0.00).toFixed(2),
        gstAmountAE: true,
        gstAmount: (0.00).toFixed(2),
        netAmountCurr: null,
        netAmount: (0.00).toFixed(2),
        bankAmountCurr: null,
        bankAmountAE: true,
        bankAmount: (0.00).toFixed(2),
        bankAmountCurrRate: (0.00).toFixed(2),
        bankChargesCurr: null,
        bankCharges: (0.00).toFixed(2),
        bankTotalAmountCurr: null,
        bankTotalAmount: (0.00).toFixed(2),
        bankTotalLocalCurr: null,
        bankTotalLocalAE: true,
        bankTotalLocal: (0.00).toFixed(2),
        bankTotalLocalCurrRate: (0.00).toFixed(2),
        chequeNo: null,
        prtCheque: false,
        isDeptMand: false,
        printDocument: null,
        policyNo: null,
        companyName: null,
        docAddress1: null,
        docAddress2: null,
        docAddress3: null,
        docAddress4: null,
        postalCode: null,
        details: null,
        statementRef: null,
        department: null,
        insuredName: null,
        claimNo: null,
        gstRegNo: null,
        taxInvoiceNo: null,
        isExistDocNo: null,
        oldFund: null,
        oldAccountNoSuffix: null,
        insdRefNo: null,
        bmBrn: null,
        bmTranType: null,
        bmDocNo: null,
        bmFund: null,
        bmAcctNoSfx: null,
        bmAcctNo: null,
        cnNo: null,
        vehRegNo: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      paymentFormLabel: {
        branch: 'Branch',
        documentNo: 'Document No.',
        transactionType: 'Transaction Type',
        docAE: 'Auto Payment No.',
        transactionDate: 'Transaction Date',
        payTo: 'Pay To',
        fromBank: 'From Bank',
        fund: 'Fund',
        accountNoSuffix: 'Suffix',
        cashBook: 'Cash Book',
        gstIO: 'GST IO',
        gstStatus: 'Status',
        gstRate: 'Rate',
        amountCurr: 'Amount Currency',
        amount: 'Amount',
        gstAmountCurr: 'GST Amount Currency',
        gstAmount: 'GST Amount',
        netAmountCurr: 'Net Amount Currency',
        netAmount: 'Net Amount',
        bankAmountCurr: 'Bank Amount Currency',
        bankAmount: 'Bank Amount',
        bankChargesCurr: 'Bank Charges Currency',
        bankCharges: 'Bank Charges',
        bankTotalAmountCurr: 'Bank Total Amount Currency',
        bankTotalAmount: 'Bank Total Amount',
        bankTotalLocalCurr: 'Bank Total Local Currency',
        bankTotalLocal: 'Bank Total Local',
        chequeNo: 'Cheque No',
        prtCheque: 'Print Cheque',
        printDocument: 'Print Document',
        addressTo: 'Address To',
        policyNo: 'Policy',
        companyName: 'Name',
        docAddress1: 'Address 1',
        docAddress2: 'Address 2',
        docAddress3: 'Address 3',
        docAddress4: 'Address 4',
        postalCode: 'Postal Code',
        details: 'Details',
        statementRef: 'Statement Reference',
        department: 'Department',
        insuredName: 'Insured Name',
        claimNo: 'Claim No',
        gstRegNo: 'GST Reg No',
        taxInvoiceNo: 'Their Tax Invoice No',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      branches: [],
      currencies: [],
      gstIO: [
        { label: '', value: 'B' },
        { label: 'O - Output', value: 'O' },
        { label: 'I - Input', value: 'I' }
      ],
      printDocOpts: [
        { label: 'I - Immediately', value: 'I' },
        { label: 'L - Later', value: 'L' },
        { label: 'N - No', value: 'N' }
      ],
      addressToOpts: [
        { label: 'A - Agent', value: 'A' },
        { label: 'I - Insured', value: 'I' },
        { label: 'E - Entered as below', value: 'E' }
      ],
      showBankNoHelpList: false,
      showAcctSufHelpList: false,
      showCurrencyHelpList: false,
      showAcctPolicyHelpList: false,
      showClmHelpList: false,
      showPayToHelpList: false,
      filtersPayToLabel: {
        accountNo: 'Account No.'
      },
      filtersPayTo: {
        accountNo: undefined
      },
      payToItems: [],
      totalItemsPayTo: 0,
      payToHeaders: [
        { text: 'Account No.', align: 'left', value: 'accountNo' },
        { text: 'Name', value: 'intermediaryName' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationPayTo: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      nowDT: formatDisplayDateTime4(new Date()),
      createdName: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
    }
  },
  watch: {
    'pagination': function (value) {
      this.performSearch(false)
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  mixins: [
    MessageMixin
  ]
}
